"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appSessionStorage = exports.appLocalStorage = exports.AppStorage = void 0;
var AppStorage = /** @class */ (function () {
    function AppStorage(storage) {
        this.storage = storage || window.localStorage;
        if (!this.isSupported()) {
            throw new Error('Storage is not supported by browser!');
        }
    }
    AppStorage.prototype.setItem = function (key, value) {
        if ('undefined' !== typeof value) {
            this.storage.setItem(key, JSON.stringify(value));
        }
    };
    AppStorage.prototype.getItem = function (key, defaultValue) {
        var value = this.storage.getItem(key);
        if ('undefined' !== typeof value) {
            if (null === value) {
                return 'undefined' !== typeof defaultValue ? defaultValue : null;
            }
            return JSON.parse(this.storage.getItem(key));
        }
        this.storage.removeItem(key);
        return null;
    };
    AppStorage.prototype.removeItem = function (key) {
        this.storage.removeItem(key);
    };
    AppStorage.prototype.clear = function () {
        this.storage.clear();
    };
    AppStorage.prototype.isSupported = function () {
        var supported = true;
        if (!this.storage) {
            supported = false;
        }
        return supported;
    };
    return AppStorage;
}());
exports.AppStorage = AppStorage;
var appLocalStorage = new AppStorage(window.localStorage);
exports.appLocalStorage = appLocalStorage;
var appSessionStorage = new AppStorage(window.sessionStorage);
exports.appSessionStorage = appSessionStorage;
